import React from 'react';
import { toUSD } from "../../util/currency-formatter";
import CustomTable from "../table/table";
import './breakdown.scss';

const TotalCostsRow = ({ totalCost }) => {
  const totalColumns = [
    { field: "label", title: "" },
    { 
      field: "total", 
      title: "", 
      class: "text-right",
      render: (item) => <span className="text-right">{toUSD(item.total)}</span>
    }
  ];
  
  const totalData = [{
    id: 'grand-total',
    label: 'Grand Total',
    total: totalCost
  }];
  
  return (
    <div className="breakdown-container">
      <div className="mt-3 border d-flex justify-content-between align-items-center p-3 grand-total">
        <h5 className="mb-0 fw-bold">Grand Total</h5>
        <h5 className="mb-0 fw-bold">{toUSD(totalCost)}</h5>
      </div>
    </div>
  );
};

export default TotalCostsRow; 